
        /// Placeholder for the reset function to prevent errors
function wcpaReset() {
    console.log("wcpaReset() function has been called.");
    // Add your reset logic here
}

$(document).ready(function() {
    // Auto-open the first toggle after page load
    const $firstTrigger = $('.toggle-triggerr.triggerr-1[data-target="#toggle-content-1"]');
    if ($firstTrigger.length) {
        const $firstContent = $('#toggle-content-1');
        const $firstCheckbox = $firstTrigger.find('.toggle-checkbox');
        
        // Open the content and set active state
        $firstContent.show(); // or use .slideDown('fast') for animation
        $firstCheckbox.prop('checked', true);
        $firstTrigger.addClass('active-triggerr');
    }

    $('.toggle-triggerr').on('click', function() {
        const $trigger = $(this);
        const $checkbox = $trigger.find('.toggle-checkbox');
        const targetContentId = $trigger.data('target');
        const $content = $(targetContentId);

        // --- UPDATED: Close other toggles and remove active state ---
        $('.toggle-content').not($content).slideUp('fast');
        $('.toggle-triggerr').not($trigger).removeClass('active-triggerr').find('.toggle-checkbox').prop('checked', false);

        // Toggle the corresponding content area
        $content.slideToggle('fast', function() {
            const isVisible = $content.is(':visible');
            $checkbox.prop('checked', isVisible);

            // --- NEW: Add or remove active class based on visibility ---
            if (isVisible) {
                $trigger.addClass('active-triggerr');
            } else {
                $trigger.removeClass('active-triggerr');
            }

            // Logic for trigger-2
            if ($trigger.hasClass('triggerr-2') && isVisible) {
                const variationSelector = $content.find(".ecom-product-single__swatch-select");
                
                if (variationSelector.length) {
                    variationSelector.off('change').on("change", function (event) {
                        console.log("Selected value:", this.value);
                        if (this.value !== 'Custom') {
                            wcpaReset();
                        }
                    });
                }
            }
        });
    });
});


// SELECT CUSTOM VARIATION ON TRIGGER

/**
 * This script handles both the visual sliding tab functionality and the
 * product variation changes based on which tab is clicked.
 * It waits for the DOM to be fully loaded before initializing.
 */
document.addEventListener('DOMContentLoaded', () => {

  // --- 1. GATHER ALL REQUIRED ELEMENTS ---
  // Elements for the visual tab UI
  const preBuiltTab = document.getElementById('preBuiltTab');
  const customBuiltTab = document.getElementById('customBuiltTab');
  const preBuiltContent = document.getElementById('preBuiltContent');
  const customBuiltContent = document.getElementById('customBuiltContent');
  const slider = document.getElementById('slider');

  // --- 2. DEFINE HELPER FUNCTIONS FOR SHOPIFY VARIATIONS ---

  /**
   * Finds all `hdt-richlist` elements and triggers a click on the "Custom" option.
   */
  function setVariationToCustom() {
    const variationRichlists = document.querySelectorAll('hdt-richlist');
    const variantIdInput = document.querySelector('form[id*="product-form"] input[name="id"]');
    
    // Exit if there are no variation lists to process
    if (!variationRichlists.length) return;

    variationRichlists.forEach((richlist) => {
      const customOptionButton = richlist.querySelector('button[value="Custom"]');
      if (customOptionButton && customOptionButton.getAttribute('aria-selected') !== 'true') {
        customOptionButton.click();
        // Dispatch events to ensure the theme and Shopify recognize the change
        richlist.dispatchEvent(new Event('change', { bubbles: true }));
        const customVariantEvent = new CustomEvent('variant:change', {
          bubbles: true,
          detail: { currentSelectedVariant: variantIdInput ? variantIdInput.value : null },
        });
        richlist.dispatchEvent(customVariantEvent);
      }
    });
    console.log('✅ Set variations to "Custom" and dispatched events.');
  }

  /**
   * Finds all `hdt-richlist` elements and resets them to the first available option.
   */
  function resetVariationToDefault() {
    const variationRichlists = document.querySelectorAll('hdt-richlist');
    const variantIdInput = document.querySelector('form[id*="product-form"] input[name="id"]');

    // Exit if there are no variation lists to process
    if (!variationRichlists.length) return;

    variationRichlists.forEach((richlist) => {
      const firstAvailableOption = richlist.querySelector('button[role="option"]:not(.is-unavailable)');
      if (firstAvailableOption && firstAvailableOption.getAttribute('aria-selected') !== 'true') {
        firstAvailableOption.click();
        // Dispatch events to ensure the theme and Shopify recognize the change
        richlist.dispatchEvent(new Event('change', { bubbles: true }));
        const customVariantEvent = new CustomEvent('variant:change', {
          bubbles: true,
          detail: { currentSelectedVariant: variantIdInput ? variantIdInput.value : null },
        });
        richlist.dispatchEvent(customVariantEvent);
      }
    });
    console.log('🔄️ Form variations reset to default.');
  }

  // --- 3. MAIN FUNCTION TO SWITCH TABS (HANDLES UI & LOGIC) ---

  /**
   * Updates the tab UI and triggers the corresponding variation logic.
   * @param {string} target - The identifier for the target tab ('preBuilt' or 'customBuilt').
   */
  function switchTab(target) {
    if (target === 'preBuilt') {
      // --- Update UI ---
      slider.style.transform = 'translateX(0%)';
      preBuiltTab.classList.add('text-white');
      preBuiltTab.classList.remove('text-gray-700');
      customBuiltTab.classList.add('text-gray-700');
      customBuiltTab.classList.remove('text-white');
      preBuiltContent.classList.remove('inactive');
      customBuiltContent.classList.add('inactive');
      
      // --- Trigger Shopify Logic ---
      resetVariationToDefault();

    } else if (target === 'customBuilt') {
      // --- Update UI ---
      slider.style.transform = 'translateX(100%)';
      customBuiltTab.classList.add('text-white');
      customBuiltTab.classList.remove('text-gray-700');
      preBuiltTab.classList.add('text-gray-700');
      preBuiltTab.classList.remove('text-white');
      customBuiltContent.classList.remove('inactive');
      preBuiltContent.classList.add('inactive');

      // --- Trigger Shopify Logic ---
      setVariationToCustom();
    }
  }

  // --- 4. ATTACH EVENT LISTENERS ---
  // Check if tab buttons exist before adding listeners
  if (preBuiltTab && customBuiltTab) {
    preBuiltTab.addEventListener('click', () => switchTab('preBuilt'));
    customBuiltTab.addEventListener('click', () => switchTab('customBuilt'));
  } else {
    console.error("Tab component buttons not found. Could not attach event listeners.");
  }
});



// ----- Reduce Price of Related Products ----- //

(() => {
    /**
     * The saving percentage to be applied.
     * For example, 0.15 represents a 15% saving.
     */
    const savingPercentage = 0.25;

    /**
     * This function finds all target price elements that haven't been updated yet,
     * calculates the new price, and updates the HTML.
     */
    const updatePrices = () => {
        // Selector for the price elements. We target elements that do NOT have the 'price-updated' class
        // to prevent processing the same element multiple times.
        const priceElements = document.querySelectorAll('.ga-product_price.money:not(.price-updated)');

        priceElements.forEach(priceElement => {
            try {
                const originalPriceText = priceElement.textContent;

                // Regex to extract currency symbol and numeric value. Handles symbols like £, $, etc.
                const priceMatches = originalPriceText.match(/([^\d.,]*)[\s]*([\d.,]+)/);

                if (!priceMatches || priceMatches.length < 3) {
                    console.warn('Could not parse price:', originalPriceText);
                    return; // Skip if format is not recognized.
                }

                const currencySymbol = priceMatches[1] || '$'; // Default to '$'
                const originalPrice = parseFloat(priceMatches[2].replace(/,/g, ''));

                if (isNaN(originalPrice)) {
                    console.warn('Parsed price is not a number:', originalPriceText);
                    return;
                }

                // Calculate the new sale price.
                const salePrice = originalPrice * (1 - savingPercentage);

                // Format prices to two decimal places.
                const formattedOriginalPrice = originalPrice.toFixed(2);
                const formattedSalePrice = salePrice.toFixed(2);

                // Create the new HTML with original price struck-through and new sale price.
                const newPriceHTML = `
                    <span class="original-price" style="text-decoration: line-through; opacity: 0.7; margin-right: 8px;">
                        ${currencySymbol}${formattedOriginalPrice}
                    </span>
                    <span class="sale-price" style="font-weight: bold; color: black;">
                        ${currencySymbol}${formattedSalePrice}
                    </span>
                `;

                // Replace the content of the price element.
                priceElement.innerHTML = newPriceHTML;
                
                // Mark this element as updated to prevent reprocessing.
                priceElement.classList.add('price-updated');

            } catch (error) {
                console.error('Error processing price element:', priceElement, error);
            }
        });
    };

    /**
     * Hides the related products header if the target widget is not visible.
     */
    const updateRelatedHeaderVisibility = () => {
        const widget = document.querySelector('.globo_widget_23931');
        const relatedHeaders = document.querySelectorAll('.relatedheader');

        // If the widget element doesn't exist or is not visible (e.g., display: none),
        // hide the related header elements.
        if (!widget || widget.offsetParent === null) {
            relatedHeaders.forEach(header => {
                header.style.display = 'none';
            });
        }
    };

    /**
     * Use a MutationObserver to watch for changes in the DOM. This is the key
     * to handling dynamically loaded content.
     */
    const observer = new MutationObserver((mutations) => {
        // When a change is detected, run our update functions.
        updatePrices();
        updateRelatedHeaderVisibility();
    });

    // Start observing the entire body of the document for added nodes and attribute changes.
    observer.observe(document.body, {
        childList: true, // Watch for direct children being added or removed
        subtree: true,   // Watch for all descendants
        attributes: true // Watch for attribute changes (like 'style' or 'class')
    });
    
    /**
     * A function to run all our update tasks together.
     */
    const runUpdateTasks = () => {
        updatePrices();
        updateRelatedHeaderVisibility();
    };

    // Run the tasks once on initial load, in case some content is not dynamically loaded.
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', runUpdateTasks);
    } else {
        runUpdateTasks();
    }
})();
/**
 * This script handles both the visual sliding tab functionality and the
 * product variation changes based on which tab is clicked.
 * It waits for the DOM to be fully loaded before initializing.
 */
document.addEventListener('DOMContentLoaded', () => {

  // --- 1. GATHER ALL REQUIRED ELEMENTS ---
  // Elements for the visual tab UI
  const preBuiltTab = document.getElementById('preBuiltTab');
  const customBuiltTab = document.getElementById('customBuiltTab');
  const preBuiltContent = document.getElementById('preBuiltContent');
  const customBuiltContent = document.getElementById('customBuiltContent');
  const slider = document.getElementById('slider');

  // --- 2. DEFINE HELPER FUNCTIONS FOR SHOPIFY VARIATIONS ---

  /**
   * Finds all `hdt-richlist` elements and triggers a click on the "Custom" option.
   */
  function setVariationToCustom() {
    const variationRichlists = document.querySelectorAll('hdt-richlist');
    const variantIdInput = document.querySelector('form[id*="product-form"] input[name="id"]');
    
    // Exit if there are no variation lists to process
    if (!variationRichlists.length) return;

    variationRichlists.forEach((richlist) => {
      const customOptionButton = richlist.querySelector('button[value="Custom"]');
      if (customOptionButton && customOptionButton.getAttribute('aria-selected') !== 'true') {
        customOptionButton.click();
        // Dispatch events to ensure the theme and Shopify recognize the change
        richlist.dispatchEvent(new Event('change', { bubbles: true }));
        const customVariantEvent = new CustomEvent('variant:change', {
          bubbles: true,
          detail: { currentSelectedVariant: variantIdInput ? variantIdInput.value : null },
        });
        richlist.dispatchEvent(customVariantEvent);
      }
    });
    console.log('✅ Set variations to "Custom" and dispatched events.');
  }

  /**
   * Finds all `hdt-richlist` elements and resets them to the first available option.
   */
  function resetVariationToDefault() {
    const variationRichlists = document.querySelectorAll('hdt-richlist');
    const variantIdInput = document.querySelector('form[id*="product-form"] input[name="id"]');

    // Exit if there are no variation lists to process
    if (!variationRichlists.length) return;

    variationRichlists.forEach((richlist) => {
      const firstAvailableOption = richlist.querySelector('button[role="option"]:not(.is-unavailable)');
      if (firstAvailableOption && firstAvailableOption.getAttribute('aria-selected') !== 'true') {
        firstAvailableOption.click();
        // Dispatch events to ensure the theme and Shopify recognize the change
        richlist.dispatchEvent(new Event('change', { bubbles: true }));
        const customVariantEvent = new CustomEvent('variant:change', {
          bubbles: true,
          detail: { currentSelectedVariant: variantIdInput ? variantIdInput.value : null },
        });
        richlist.dispatchEvent(customVariantEvent);
      }
    });
    console.log('🔄️ Form variations reset to default.');
  }

  // --- 3. MAIN FUNCTION TO SWITCH TABS (HANDLES UI & LOGIC) ---

  /**
   * Updates the tab UI and triggers the corresponding variation logic.
   * @param {string} target - The identifier for the target tab ('preBuilt' or 'customBuilt').
   */
  function switchTab(target) {
    if (target === 'preBuilt') {
      // --- Update UI ---
      slider.style.transform = 'translateX(0%)';
      preBuiltTab.classList.add('text-white');
      preBuiltTab.classList.remove('text-gray-700');
      customBuiltTab.classList.add('text-gray-700');
      customBuiltTab.classList.remove('text-white');
      preBuiltContent.classList.remove('inactive');
      customBuiltContent.classList.add('inactive');
      
      // --- Trigger Shopify Logic ---
      resetVariationToDefault();

    } else if (target === 'customBuilt') {
      // --- Update UI ---
      slider.style.transform = 'translateX(100%)';
      customBuiltTab.classList.add('text-white');
      customBuiltTab.classList.remove('text-gray-700');
      preBuiltTab.classList.add('text-gray-700');
      preBuiltTab.classList.remove('text-white');
      customBuiltContent.classList.remove('inactive');
      preBuiltContent.classList.add('inactive');

      // --- Trigger Shopify Logic ---
      setVariationToCustom();
    }
  }

  // --- 4. ATTACH EVENT LISTENERS ---
  // Check if tab buttons exist before adding listeners
  if (preBuiltTab && customBuiltTab) {
    preBuiltTab.addEventListener('click', () => switchTab('preBuilt'));
    customBuiltTab.addEventListener('click', () => switchTab('customBuilt'));
  } else {
    console.error("Tab component buttons not found. Could not attach event listeners.");
  }
});




//----------------------------------------------------------------------------------------  AUTO OPEN BUY NEW -------------------------------------------- -------------------------------------------- //






// -------------------------------------------- disable supersycle on page load   -------------------------------------------- //

document.addEventListener('DOMContentLoaded', () => {

  // 1. Set the initial state on page load
  window.supercycleStopSync = true;
  console.log('Page loaded: window.supercycleStopSync is now true.');

  // --- Button 1: Sets the variable back to TRUE ---
  // Finds the element with the data-target attribute
  const setSyncTrueButton = document.querySelector('[data-target="#toggle-content-1"]');

  if (setSyncTrueButton) {
    setSyncTrueButton.addEventListener('click', () => {
      // On click, set the variable to true
      window.supercycleStopSync = true;
      console.log('Toggle (on) clicked: window.supercycleStopSync is now true.');
    });
  } else {
    // This message appears if the element isn't found
    console.error('Error: Element with data-target="#toggle-content-1" was not found.');
  }

  // --- Button 2: Sets the variable to FALSE ---
  // Finds the element with the ID attribute
  const setSyncFalseButton = document.querySelector('[data-target="#toggle-content-3"]');

  if (setSyncFalseButton) {
    setSyncFalseButton.addEventListener('click', () => {
      // On click, set the variable to false
      window.supercycleStopSync = false;
      console.log('Toggle (off) clicked: window.supercycleStopSync is now false.');
    });
  } else {
    // This message appears if the element isn't found
    console.error('Error: Element with ID "toggle-content-3" was not found.');
  }

});




// --------------------------- reset form values when rental clicked ------------------------------------ //
/**
 * This script resets all form variant pickers on the page to their
 * default values when a specific toggle button is clicked.
 */
document.addEventListener('DOMContentLoaded', () => {

  // --- 1. DEFINE THE RESET FUNCTION ---

  /**
   * Finds all `hdt-richlist` elements on the page and resets their
   * value to the first available option.
   */
  function resetAllFormVariations() {
    // Select all variant richlists on the page
    const variationRichlistsToReset = document.querySelectorAll('hdt-richlist');

    // If no variant pickers are found, stop the function.
    if (!variationRichlistsToReset.length) {
      console.warn('No variant pickers found to reset.');
      return;
    }

    // Find a generic variant ID input for event dispatching purposes
    const variantIdInput = document.querySelector('form[id*="product-form"] input[name="id"]');

    // Loop through each of the variant pickers
    variationRichlistsToReset.forEach((richlist) => {
      // Find the first option that is not sold out or unavailable
      const firstAvailableOption = richlist.querySelector('button[role="option"]:not(.is-unavailable)');
      
      // If a valid option is found and it's not already selected, click it.
      if (firstAvailableOption && firstAvailableOption.getAttribute('aria-selected') !== 'true') {
        firstAvailableOption.click();

        // Dispatch events to ensure the theme and Shopify's backend recognize the change
        richlist.dispatchEvent(new Event('change', { bubbles: true }));
        const customVariantEvent = new CustomEvent('variant:change', {
          bubbles: true,
          detail: { currentSelectedVariant: variantIdInput ? variantIdInput.value : null },
        });
        richlist.dispatchEvent(customVariantEvent);
      }
    });

    console.log('🔄️ All form variations have been reset to their default values.');
  }


  // --- 2. ATTACH THE EVENT LISTENER ---

  // Find the specific toggle button you want to use as the trigger
  const resetButton = document.querySelector('[data-target="#toggle-content-3"]');

  if (resetButton) {
    // Add a click event listener
    resetButton.addEventListener('click', (event) => {
      // Run the reset function when the button is clicked
      resetAllFormVariations();
    });
  } else {
    // This message will show in the browser's console if the button can't be found
    console.error('The specified reset toggle button ([data-target="#toggle-content-3"]) was not found.');
  }

});





/**
 * @file This script observes specific navigation elements for changes to their 'aria-expanded' attribute.
 * When any of the observed elements are expanded, it hides the '.hdt-shop-control' div with a fade transition.
 */

document.addEventListener('DOMContentLoaded', function() {
    (function() {
        // --- 1. Element Selection ---
        // Use querySelectorAll to get a list of ALL matching elements, not just the first one.
        const observedElements = document.querySelectorAll('details[is="hdt-header-menu"]');
        const targetElement = document.querySelector(".hdt-shop-control");

        // --- 2. Safety Check ---
        // Adjust the check to see if any elements were found.
        if (observedElements.length === 0 || !targetElement) {
            console.error("Observer script: One or more target elements could not be found. Please verify selectors.");
            return;
        }

        // --- 3. Apply Transition Style ---
       

        // --- 4. Visibility Logic ---
        // This function now checks if ANY of the observed menus are expanded.
        const handleVisibility = () => {
            // The .some() method checks if at least one element in the array passes the test.
            const isAnyMenuExpanded = Array.from(observedElements).some(
                el => el.getAttribute("aria-expanded") === "true"
            );

            if (isAnyMenuExpanded) {
                targetElement.style.opacity = '0';
                targetElement.style.visibility = 'hidden';
            } else {
                targetElement.style.opacity = '1';
                targetElement.style.visibility = 'visible';
            }
        };

        // --- 5. Mutation Observer Setup ---
        // The observer's callback will simply run our check function.
        const observer = new MutationObserver(handleVisibility);

        // --- 6. Start Observing ---
        // Loop through each of the menu elements found and attach the same observer to all of them.
        observedElements.forEach(element => {
            observer.observe(element, {
                attributes: true,
                attributeFilter: ['aria-expanded'] // More efficient: only watch for this specific attribute.
            });
        });

        // --- 7. Initial State ---
        // Run once on load to set the correct initial state.
        handleVisibility();

    })();
});